(function() {
  'use strict';

  var PRIKPOST_LINK_PREFIX = '_prikpost_link_';
  var QTY_SELECTOR = '.quantity__input, .qty, [name="quantity"]';
  var FOR_OTHER_SELECTOR = '[data-prikpost-for="other"].prikpost-person-toggle-btn--active';
  var CART_TRIGGER_SELECTOR = '#cartLink';
  var cleanupInFlight = false;

  var GENDER_MAP = {
    'men': 'male',
    'man': 'male',
    'mannen': 'male',
    'männer': 'male',
    'herren': 'male',
    'women': 'female',
    'woman': 'female',
    'vrouwen': 'female',
    'frauen': 'female',
    'damen': 'female'
  };

  function getTranslations(addon) {
    return {
      testNumber: addon.dataset.prikpostTTestNumber || 'Test __NUM__',
      forMe: addon.dataset.prikpostTForMe || 'For me',
      forOther: addon.dataset.prikpostTForOther || 'Someone else',
      firstName: addon.dataset.prikpostTFirstName || 'First name',
      lastName: addon.dataset.prikpostTLastName || 'Last name',
      birthdate: addon.dataset.prikpostTBirthdate || 'Date of birth',
      gender: addon.dataset.prikpostTGender || 'Gender',
      selectGender: addon.dataset.prikpostTSelectGender || 'Select gender',
      genderMale: addon.dataset.prikpostTGenderMale || 'Male',
      genderFemale: addon.dataset.prikpostTGenderFemale || 'Female',
      genderOther: addon.dataset.prikpostTGenderOther || 'Other',
      error: addon.dataset.prikpostTError || 'An error occurred.'
    };
  }

  function isCardForOther(card) {
    return card.querySelector(FOR_OTHER_SELECTOR) !== null;
  }

  function validateField(input, checkFn) {
    input.classList.remove('error');
    if (!checkFn(input)) {
      input.classList.add('error');
      return false;
    }
    return true;
  }

  var escapeDiv = document.createElement('div');
  function escapeHtml(str) {
    escapeDiv.textContent = str;
    return escapeDiv.innerHTML;
  }

  function updateCardHeader(header, productTitle, quantity, index) {
    var html = '<span class="prikpost-person-header-title">' + escapeHtml(productTitle) + '</span>';
    if (quantity > 1) {
      html += '<span class="prikpost-person-header-number">' + (index + 1) + '</span>';
    }
    header.innerHTML = html;
  }

  function createPersonCard(index, translations, productTitle, quantity) {
    var card = document.createElement('div');
    card.className = 'prikpost-person-card';
    card.dataset.prikpostPersonIndex = index;

    card.innerHTML =
      '<div class="prikpost-person-header"></div>' +
      '<div class="prikpost-person-toggle">' +
        '<button type="button" class="prikpost-person-toggle-btn prikpost-person-toggle-btn--active" data-prikpost-for="me">' +
          escapeHtml(translations.forMe) +
        '</button>' +
        '<button type="button" class="prikpost-person-toggle-btn" data-prikpost-for="other">' +
          escapeHtml(translations.forOther) +
        '</button>' +
      '</div>' +
      '<div class="prikpost-person-name-fields" data-prikpost-name-fields style="display: none;">' +
        '<div class="prikpost-field">' +
          '<label>' + escapeHtml(translations.firstName) + ' <span class="required">*</span></label>' +
          '<input type="text" class="prikpost-input" data-prikpost-first-name placeholder="' + escapeHtml(translations.firstName) + '">' +
        '</div>' +
        '<div class="prikpost-field">' +
          '<label>' + escapeHtml(translations.lastName) + ' <span class="required">*</span></label>' +
          '<input type="text" class="prikpost-input" data-prikpost-last-name placeholder="' + escapeHtml(translations.lastName) + '">' +
        '</div>' +
      '</div>' +
      '<div class="prikpost-person-fields">' +
        '<div class="prikpost-field">' +
          '<label>' + escapeHtml(translations.birthdate) + ' <span class="required">*</span></label>' +
          '<input type="date" class="prikpost-input" data-prikpost-birthdate>' +
        '</div>' +
        '<div class="prikpost-field">' +
          '<label>' + escapeHtml(translations.gender) + ' <span class="required">*</span></label>' +
          '<select class="prikpost-select" data-prikpost-gender>' +
            '<option value="">' + escapeHtml(translations.selectGender) + '</option>' +
            '<option value="male">' + escapeHtml(translations.genderMale) + '</option>' +
            '<option value="female">' + escapeHtml(translations.genderFemale) + '</option>' +
            '<option value="other">' + escapeHtml(translations.genderOther) + '</option>' +
          '</select>' +
        '</div>' +
      '</div>';

    updateCardHeader(card.querySelector('.prikpost-person-header'), productTitle, quantity, index);

    var toggleBtns = card.querySelectorAll('[data-prikpost-for]');
    var nameFields = card.querySelector('[data-prikpost-name-fields]');

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        toggleBtns.forEach(function(b) { b.classList.remove('prikpost-person-toggle-btn--active'); });
        btn.classList.add('prikpost-person-toggle-btn--active');

        var isOther = btn.dataset.prikpostFor === 'other';
        nameFields.style.display = isOther ? '' : 'none';

        if (!isOther) {
          var firstNameInput = card.querySelector('[data-prikpost-first-name]');
          var lastNameInput = card.querySelector('[data-prikpost-last-name]');
          if (firstNameInput) { firstNameInput.value = ''; firstNameInput.classList.remove('error'); }
          if (lastNameInput) { lastNameInput.value = ''; lastNameInput.classList.remove('error'); }
        }
      });
    });

    var birthdateInput = card.querySelector('[data-prikpost-birthdate]');
    if (birthdateInput) {
      birthdateInput.addEventListener('click', function() {
        if (this.showPicker) this.showPicker();
      });
    }

    return card;
  }

  function renderPersonCards(addon) {
    var container = addon.querySelector('[data-prikpost-persons]');
    if (!container) return;

    var form = addon.closest('form');
    var quantityInput = form ? form.querySelector(QTY_SELECTOR) : null;
    var quantity = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;

    var translations = addon._prikpostTranslations;
    var productTitle = addon._prikpostProductTitle;
    var existingCards = container.querySelectorAll('.prikpost-person-card');
    var currentCount = existingCards.length;

    for (var i = currentCount - 1; i >= quantity; i--) {
      existingCards[i].remove();
    }

    for (var j = currentCount; j < quantity; j++) {
      var card = createPersonCard(j, translations, productTitle, quantity);
      container.appendChild(card);
    }

    container.querySelectorAll('.prikpost-person-card').forEach(function(card, idx) {
      card.dataset.prikpostPersonIndex = idx;
      var header = card.querySelector('.prikpost-person-header');
      if (header) {
        updateCardHeader(header, productTitle, quantity, idx);
      }
    });
  }

  function bindQuantityListener(addon) {
    var form = addon.closest('form');
    if (!form) return;

    var quantityInput = form.querySelector(QTY_SELECTOR);
    if (!quantityInput) return;

    var renderTimeout = null;
    function debouncedRender() {
      if (renderTimeout) clearTimeout(renderTimeout);
      renderTimeout = setTimeout(function() { renderPersonCards(addon); }, 30);
    }

    quantityInput.addEventListener('change', debouncedRender);
    quantityInput.addEventListener('input', debouncedRender);

    var qtyContainer = quantityInput.closest('quantity-input, .qtyField');
    if (qtyContainer) {
      qtyContainer.querySelectorAll('button').forEach(function(btn) {
        btn.addEventListener('click', debouncedRender);
      });
    }

    addon._prikpostQtyObserver = new MutationObserver(debouncedRender);
    addon._prikpostQtyObserver.observe(quantityInput, { attributes: true, attributeFilter: ['value'] });
  }

  function presetGenderFromVariant(variant) {
    if (!variant || !variant.options) return;
    var addons = document.querySelectorAll('[data-prikpost-addon]');
    addons.forEach(function(addon) {
      var genderSelects = addon.querySelectorAll('[data-prikpost-gender]');
      genderSelects.forEach(function(genderSelect) {
        for (var i = 0; i < variant.options.length; i++) {
          var mapped = GENDER_MAP[variant.options[i].toLowerCase()];
          if (mapped) {
            genderSelect.value = mapped;
            return;
          }
        }
      });
    });
  }

  function initGenderPreset() {
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var jsonEl = variantSelects.querySelector('script[type="application/json"]');
      if (jsonEl) {
        try {
          var variants = JSON.parse(jsonEl.textContent);
          var params = new URLSearchParams(window.location.search);
          var selectedId = params.get('variant');
          var selected = selectedId
            ? variants.find(function(v) { return String(v.id) === selectedId; })
            : variants.find(function(v) { return v.available; });
          if (selected) presetGenderFromVariant(selected);
        } catch(e) {}
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        if (event && event.data && event.data.variant) {
          presetGenderFromVariant(event.data.variant);
        }
      });
    }
  }

  function initPrikpostAddon() {
    var addons = document.querySelectorAll('[data-prikpost-addon]');

    addons.forEach(function(addon) {
      if (addon.dataset.prikpostInitialized === 'true') {
        return;
      }

      addon.dataset.prikpostInitialized = 'true';

      // Cache translations and product title once
      addon._prikpostTranslations = getTranslations(addon);
      addon._prikpostProductTitle = addon.dataset.prikpostProductTitle || '';

      var popupBtn = addon.querySelector('[data-prikpost-popup-open]');
      var popupEl = addon.querySelector('[data-prikpost-popup]');
      if (popupBtn && popupEl) {
        var closeBtn = popupEl.querySelector('.close-btn');
        popupBtn.addEventListener('click', function() {
          popupEl.style.display = 'block';
          document.documentElement.classList.add('no-scroll');
        });
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            popupEl.style.display = 'none';
            document.documentElement.classList.remove('no-scroll');
          });
        }
        window.addEventListener('click', function(evt) {
          if (evt.target === popupEl) {
            popupEl.style.display = 'none';
            document.documentElement.classList.remove('no-scroll');
          }
        });
      }

      var checkbox = addon.querySelector('[data-prikpost-checkbox]');
      var hiddenInput = addon.querySelector('[data-prikpost-hidden]');
      var fieldsContainer = addon.querySelector('[data-prikpost-fields]');

      if (checkbox && hiddenInput) {
        checkbox.addEventListener('change', function() {
          hiddenInput.value = this.checked ? 'true' : 'false';
          if (fieldsContainer) {
            fieldsContainer.classList.toggle('prikpost-fields--visible', this.checked);
          }
        });
      }

      renderPersonCards(addon);
      bindQuantityListener(addon);

      var form = addon.closest('form');
      if (form && !form.dataset.prikpostFormInitialized) {
        form.dataset.prikpostFormInitialized = 'true';

        form.addEventListener('submit', function(evt) {
          var prikpostEnabled = isPrikpostEnabled(addon);

          if (prikpostEnabled) {
            if (!validateAllPersonCards(addon)) {
              evt.preventDefault();
              evt.stopPropagation();
              evt.stopImmediatePropagation();
              return;
            }
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            handlePrikpostSubmit(form, addon);
          }
        }, true);
      }
    });
  }

  function validateAllPersonCards(addon) {
    var cards = addon.querySelectorAll('.prikpost-person-card');
    var allValid = true;
    var firstErrorField = null;

    cards.forEach(function(card) {
      var birthdateInput = card.querySelector('[data-prikpost-birthdate]');
      var genderSelect = card.querySelector('[data-prikpost-gender]');

      if (isCardForOther(card)) {
        var firstNameInput = card.querySelector('[data-prikpost-first-name]');
        var lastNameInput = card.querySelector('[data-prikpost-last-name]');

        if (firstNameInput && !validateField(firstNameInput, function(el) { return el.value.trim(); })) {
          allValid = false;
          if (!firstErrorField) firstErrorField = firstNameInput;
        }

        if (lastNameInput && !validateField(lastNameInput, function(el) { return el.value.trim(); })) {
          allValid = false;
          if (!firstErrorField) firstErrorField = lastNameInput;
        }
      }

      if (birthdateInput && !validateField(birthdateInput, function(el) { return el.value; })) {
        allValid = false;
        if (!firstErrorField) firstErrorField = birthdateInput;
      }

      if (genderSelect && !validateField(genderSelect, function(el) { return el.value; })) {
        allValid = false;
        if (!firstErrorField) firstErrorField = genderSelect;
      }
    });

    if (!allValid && firstErrorField) {
      firstErrorField.focus();
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return allValid;
  }

  function isPrikpostEnabled(addon) {
    if (addon.dataset.prikpostOnly === 'true') {
      return true;
    }

    var checkbox = addon.querySelector('[data-prikpost-checkbox]');
    return checkbox && checkbox.checked;
  }

  function handlePrikpostSubmit(form, addon) {
    var formData = new FormData(form);
    var variantId = formData.get('id');
    var prikpostVariantId = addon.dataset.prikpostVariantId;
    var mainProductId = addon.dataset.prikpostProductId;
    var translations = addon._prikpostTranslations;

    var baseProperties = {};
    for (var pair of formData.entries()) {
      if (pair[0].startsWith('properties[')) {
        var propName = pair[0].replace('properties[', '').replace(']', '');
        baseProperties[propName] = pair[1];
      }
    }

    var cards = addon.querySelectorAll('.prikpost-person-card');
    var timestamp = Date.now();
    var items = [];

    cards.forEach(function(card, index) {
      var birthdateInput = card.querySelector('[data-prikpost-birthdate]');
      var genderSelect = card.querySelector('[data-prikpost-gender]');
      var forOther = isCardForOther(card);

      var birthdate = birthdateInput ? birthdateInput.value : '';
      var gender = genderSelect ? genderSelect.value : '';

      var linkId = PRIKPOST_LINK_PREFIX + mainProductId + '_' + timestamp + '_' + index;

      var serviceProperties = {
        '_prikpost_link': linkId,
        '_prikpost_service': 'true',
        '_for_other': forOther ? 'true' : 'false',
        'birth_date': birthdate,
        'sex': gender
      };

      if (forOther) {
        var firstNameInput = card.querySelector('[data-prikpost-first-name]');
        var lastNameInput = card.querySelector('[data-prikpost-last-name]');
        serviceProperties['first_name'] = firstNameInput ? firstNameInput.value.trim() : '';
        serviceProperties['last_name'] = lastNameInput ? lastNameInput.value.trim() : '';
      }

      var mainProperties = {};
      for (var key in baseProperties) {
        mainProperties[key] = baseProperties[key];
      }
      mainProperties['_prikpost_link'] = linkId;

      items.push({
        id: parseInt(prikpostVariantId),
        quantity: 1,
        properties: serviceProperties
      });

      items.push({
        id: parseInt(variantId),
        quantity: 1,
        properties: mainProperties
      });
    });

    var submitButton = form.querySelector('[type="submit"]');
    var productForm = form.closest('product-form');

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      var spinner = submitButton.querySelector('.btn_spinner');
      if (spinner) spinner.classList.remove('hidden');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) { throw err; });
      }
      return response.json();
    })
    .then(function(data) {
      var cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer) {
        return fetch('/?sections=cart-drawer')
          .then(function(res) { return res.json(); })
          .then(function(sections) {
            var cartDrawerHTML = sections['cart-drawer'];
            var response = {
              items: data.items || [data],
              sections: { 'cart-drawer': cartDrawerHTML }
            };
            cartDrawer.renderContents(response);
          });
      } else {
        window.location = '/cart';
      }
    })
    .catch(function(error) {
      console.error('Error adding prikpost items to cart:', error);
      if (productForm && productForm.handleErrorMessage) {
        productForm.handleErrorMessage(error.description || error.message || translations.error);
      }
    })
    .finally(function() {
      if (submitButton) {
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
        var spinner = submitButton.querySelector('.btn_spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }

  function syncPrikpostQuantities() {
    document.addEventListener('change', function(evt) {
      var input = evt.target;
      if (!input.matches('.quantity__input, .qty')) return;

      var cartItem = input.closest('.cart-item, .cart__row, [id^="CartDrawer-Item-"]');
      if (!cartItem) return;

      var prikpostLink = cartItem.dataset.prikpostLink;
      var isPrikpostService = cartItem.dataset.prikpostService === 'true';

      if (prikpostLink && !isPrikpostService) {
        var newQuantity = parseInt(input.value) || 0;
        syncLinkedPrikpostItem(prikpostLink, newQuantity);
      }
    });
  }

  function syncLinkedPrikpostItem(linkId, newQuantity) {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var updates = {};

        cart.items.forEach(function(item, index) {
          if (item.properties &&
              item.properties['_prikpost_link'] === linkId &&
              item.properties['_prikpost_service'] === 'true') {
            updates[index + 1] = newQuantity;
          }
        });

        if (Object.keys(updates).length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }
      })
      .catch(function(error) {
        console.error('Error syncing prikpost quantity:', error);
      });
  }

  function handlePrikpostRemoval() {
    document.addEventListener('click', function(evt) {
      var removeButton = evt.target.closest('cart-remove-button');
      if (!removeButton) return;

      var cartItem = removeButton.closest('[data-prikpost-link]');
      if (!cartItem) return;

      var linkId = cartItem.dataset.prikpostLink;
      if (!linkId) return;

      var mainItem = document.querySelector(
        '[data-prikpost-link="' + linkId + '"]:not([data-prikpost-service="true"])'
      );
      var serviceItem = document.querySelector(
        '[data-prikpost-link="' + linkId + '"][data-prikpost-service="true"]'
      );

      if (!mainItem || !serviceItem) return;

      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      var mainKey = mainItem.dataset.cartItemKey;
      var serviceKey = serviceItem.dataset.cartItemKey;

      if (!mainKey || !serviceKey) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: serviceKey, quantity: 0 })
      })
        .then(function() {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: mainKey, quantity: 0 })
          });
        })
        .then(function() {
          return refreshCartUI();
        });
    }, true);
  }

  function refreshCartUI() {
    var cartDrawer = document.querySelector('cart-drawer');
    var cartForm = document.querySelector('.cart__contents, #cart-form, form[action="/cart"]');

    if (cartDrawer && cartDrawer.closest('.ctdrawer.active, .ctdrawer[open]')) {
      return fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function(res) { return res.json(); })
        .then(function(sections) {
          if (sections && sections['cart-drawer']) {
            cartDrawer.renderContents({
              sections: { 'cart-drawer': sections['cart-drawer'] }
            });
          }
        })
        .catch(function() {
          window.location.reload();
        });
    } else if (cartForm || window.location.pathname === '/cart') {
      window.location.reload();
      return Promise.resolve();
    }
    return Promise.resolve();
  }

  function cleanupOrphanedPrikpostItems() {
    if (cleanupInFlight) return Promise.resolve();
    cleanupInFlight = true;

    return fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var mainProductLinks = new Set();
        var prikpostItems = [];

        cart.items.forEach(function(item) {
          if (item.properties && item.properties['_prikpost_link']) {
            if (item.properties['_prikpost_service'] === 'true') {
              prikpostItems.push({
                key: item.key,
                linkId: item.properties['_prikpost_link']
              });
            } else {
              mainProductLinks.add(item.properties['_prikpost_link']);
            }
          }
        });

        var orphanedItems = prikpostItems.filter(function(item) {
          return !mainProductLinks.has(item.linkId);
        });

        if (orphanedItems.length > 0) {
          var removePromises = orphanedItems.map(function(item) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          });

          return Promise.all(removePromises).then(function() {
            return refreshCartUI();
          });
        }
      })
      .catch(function(error) {
        console.error('Error cleaning up prikpost items:', error);
      })
      .then(function() {
        cleanupInFlight = false;
      }, function() {
        cleanupInFlight = false;
      });
  }

  function initOrphanCleanup() {
    cleanupOrphanedPrikpostItems();

    document.addEventListener('click', function(evt) {
      if (evt.target.closest(CART_TRIGGER_SELECTOR)) {
        cleanupOrphanedPrikpostItems();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initPrikpostAddon();
      initGenderPreset();
      syncPrikpostQuantities();
      handlePrikpostRemoval();
      initOrphanCleanup();
    });
  } else {
    initPrikpostAddon();
    initGenderPreset();
    syncPrikpostQuantities();
    handlePrikpostRemoval();
    initOrphanCleanup();
  }

  document.addEventListener('shopify:section:load', initPrikpostAddon);

  window.PrikpostAddon = {
    init: initPrikpostAddon,
    cleanup: cleanupOrphanedPrikpostItems
  };

})();
